import { type UseQueryResult } from '@tanstack/react-query';
import { type ApiListResult, useApiList, useApiQuery } from '../../../lib/api/hooks.js';
import { propertySetupEndpoints } from './endpoints.js';
import {
  propertySetupGateways,
  propertySetupResponse,
  setupPropertyRow,
  type PropertySetupGateways,
  type PropertySetupResponse,
  type SetupPropertyRow,
} from './schemas.js';

/**
 * Reads for the Property Setup module.
 */

export function useSetupProperties(): UseQueryResult<ApiListResult<SetupPropertyRow>> {
  return useApiList({
    resource: 'setup-properties',
    path: propertySetupEndpoints.properties,
    schema: setupPropertyRow,
    params: {
      page: 1,
      pageSize: 100,
      scope: { status: 'ACTIVE' },
    },
  });
}

export function usePropertySetup(propertyId: string): UseQueryResult<PropertySetupResponse> {
  return useApiQuery({
    queryKey: ['property-setup', propertyId],
    path: propertySetupEndpoints.setup(propertyId),
    schema: propertySetupResponse,
    enabled: propertyId !== '',
  });
}

export function usePropertySetupGateways(
  propertyId: string,
): UseQueryResult<PropertySetupGateways> {
  return useApiQuery({
    queryKey: ['property-setup', 'gateways', propertyId],
    path: propertySetupEndpoints.gateways(propertyId),
    schema: propertySetupGateways,
    enabled: propertyId !== '',
  });
}
